import React from "react"

export default React.createContext({
    page: 1,
    vatRates: [],
    typeFilters: "",
    showFilters: false,
    filters: {},
    openFilters: () => {},
    closeFilters: () => {},
    validFilters: () => {},
    filterValues: {}
})
